module.exports = __webpack_public_path__ + "img/icon-default.4b8a8582.png";